import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import { isSameHour, isSameMinute } from 'date-fns';
import { IVehicleDetailsTask } from './task-vehicle-details.component';
import addHours from 'date-fns/addHours';

@Component({
  selector: 'task-time-and-location-container',
  templateUrl: './task-time-and-location-container.component.html',
  styleUrls: ['./task-time-and-location-container.component.scss', './vertical-list-dots.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskTimeAndLocationContainerComponent {
  @HostBinding('class.flex-grow-1') flexGrow = true;

  @Input() isPickup: boolean = false;

  @Input() task: IVehicleDetailsTask;

  @Input() isCarryOver: boolean;

  @Input() styleType = 1;

  @Input() location: {
    businessName?: string;
    city?: string;
    postcode?: string;
    postal_town?: string;
    street_number?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    addressDisplay?: string;
    addressDisplaySingleLine?: string;
  };

  @Input() isFirstItem: boolean;

  @Input() isLastItem: boolean;

  @Input() showTaskBadges: boolean;

  @Input() earliestDateTime: string;

  @Input() latestDateTime: string;

  @Input() taskNumber: number;

  @Input() hidePickupLabel: boolean;

  @Input() hideDropoffLabel: boolean;

  @Input() arriveHomeEarliest!: string;
  @Input() arriveHomeLatest!: string;
  @Input() leaveHomeEarliest!: string;
  @Input() leaveHomeLatest!: string;

  @Input() scheduledDateTime: string;

  @Input() isRoute: boolean = false;

  get earliestAsDateInstance(): Date {
    return new Date(this.earliestDateTime);
  }

  get latestAsDateInstance(): Date {
    return new Date(this.latestDateTime);
  }

  public get dateString(): string {
    return this.formatDateString(this.earliestDateTime, this.latestDateTime);
  }

  public get scheduledDateString(): string {
    if (this.isRoute) {
      return '';
    }
    return this.scheduledDateTime
      ? this.formatDateString(this.scheduledDateTime, addHours(new Date(this.scheduledDateTime), 1))
      : '';
  }

  public get timeString(): string {
    return this.formatTimeString(this.earliestDateTime, this.latestDateTime);
  }

  formatDateString(earliestDateTime: string, latestDateTime: string | Date): string {
    const earliestAsDateInstance = new Date(earliestDateTime);
    const latestAsDateInstance = new Date(latestDateTime);

    if (isSameDay(earliestAsDateInstance, latestAsDateInstance)) {
      let from = format(new Date(earliestDateTime), 'EEE, do MMM HH:mm');
      let to = format(new Date(latestDateTime), 'HH:mm');
      return from + ' - ' + to;
    } else {
      let from = format(new Date(earliestDateTime), 'EEE, do MMM HH:mm');
      let to = format(new Date(latestDateTime), 'EEE, do MMM HH:mm');
      return from + ' - ' + to;
    }
  }

  formatTimeString(earliestDateTime: string, latestDateTime: string): string {
    const earliestAsDateInstance = new Date(earliestDateTime);
    const latestAsDateInstance = new Date(latestDateTime);
    let result = format(earliestAsDateInstance, 'H:mm');
    if (
      isSameHour(latestAsDateInstance, earliestAsDateInstance) &&
      isSameMinute(latestAsDateInstance, earliestAsDateInstance)
    ) {
      return result;
    }
    return result + ' - ' + format(latestAsDateInstance, 'H:mm');
  }
}
